// src/App.js - VOLLSTÄNDIG KORRIGIERT MIT JWT-TOKEN
import React, { useState, useEffect } from 'react';
import TabTitel from './components/TabTitel';
import AnmeldenPage from './pages/AnmeldenPage';
import ZuschauerPage from './pages/ZuschauerPage';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import useVersionCheck from './hooks/useVersionCheck';

// ✅ Zentrale Styles

// ✅ Pages - Korrekte Pfade
import MeineSchulePage        from './pages/MeineSchulePage';
import SicherheitPage         from './pages/SicherheitPage';
import DojoSSOPage            from './pages/DojoSSOPage';
import MainDashboard          from './components/dashboard/MainDashboard';

// ✅ Error Boundary
import ErrorBoundary          from './components/ErrorBoundary';

// ✅ Auth
import RankingPage            from './pages/RankingPage';
import EinladungPage         from './pages/EinladungPage';
import ClubRegistrationPage   from './pages/Club/ClubRegistrationPage';

// ✅ Club
import ClubEditModal          from './components/club/ClubEditModal';

// ✅ Öffentliches Turnier-Listing
import TurnierListe            from './components/turnier/TurnierListe';
import VeranstalterLandingPage from './pages/VeranstalterLandingPage';
import EventsMarketingPage    from './pages/EventsMarketingPage';
import AppsPage               from './pages/AppsPage';

// ✅ ERWEITERT: Registration System Components
import TurnierRegistrationPage from './pages/Turniere/TurnierRegistrationPage';
import AnmeldungBestaetigung   from './pages/Registration/AnmeldungBestaetigung';

// ✅ Formen-Schreiber (Standalone-Fenster)
import FormenSchreiberDashboard from './components/dashboard/FormenSchreiberDashboard';

// ✅ SV-Schreiber (Neues dunkles Wertungsportal für Selbstverteidigung)
import SVSchreiberPage from './pages/SVSchreiberPage';

// ✅ Siegerehrung Display (Standalone-Fenster für zweiten Bildschirm)
import SiegerehrungDisplayPage from './pages/SiegerehrungDisplayPage';

// ✅ Rumble Sieger Display (Festive winner screen für Rumble Belt Mode)
import RumbleSiegerDisplayPage from './pages/RumbleSiegerDisplayPage';

// ✅ Winner Display (Globaler Sieger-Bildschirm, Japan Dark Prestige)
import WinnerDisplayPage from './pages/WinnerDisplayPage';

// ✅ Bruchtest Display (Vollbild für zweiten Bildschirm)
import BruchtestDisplayPage from './pages/BruchtestDisplayPage';

// Leinwand fuer die Formen-Wertung (zweiter Bildschirm oder anderer Rechner)
import FormenDisplayPage from './pages/FormenDisplayPage';

// Informationsbildschirm: welcher Kampfrichter an welcher Kampffläche steht
import KampfrichterDisplayPage from './pages/KampfrichterDisplayPage';

// ✅ Vereinsdashboard
import VereinsDashboard from './pages/Verein/VereinsDashboard';

// ✅ Admin Platform (Super-Admin)
import AdminPlatformDashboard from './pages/Admin/AdminPlatformDashboard';

// ✅ Öffentliche Prüfungsanmeldung
import PruefungsAnmeldungPage from './pages/PruefungsAnmeldungPage';
import CampRegistrationPage from './pages/CampRegistrationPage';

// ✅ Öffentliche Ergebnisseite
import TurnierErgebnissePage from './pages/TurnierErgebnissePage';
import UmfragePage from './pages/UmfragePage';
import OeffentlicheErgebnisse from './pages/OeffentlicheErgebnisse';

// ✅ Kämpfer-Aufruf Display + Schreiber-Steuerung
import AufrufDisplayPage from './pages/AufrufDisplayPage';
import AufrufControlPage from './pages/AufrufControlPage';
import LeitstellePage from './pages/LeitstellePage';
import TurniertagPage from './pages/TurniertagPage';
import AnsageStationPage from './pages/AnsageStationPage';

// ✅ Öffentliche Turnier-Detailseite
import TurnierInfoPage from './pages/TurnierInfoPage';
import KontaktPage from './pages/KontaktPage';

// ✅ Athleten-Registrierung & Dashboard
import RegistrationPage from './pages/RegistrationPage';
import AthleteDashboard from './pages/AthleteDashboard';

// ✅ Offline-Banner
import OfflineBanner from './components/OfflineBanner';

// ✅ QR Self-Service Schnellregistrierung (öffentlich, kein Login)
import QuickRegPage from './pages/QuickRegPage';
import VoranmeldungPage from './pages/VoranmeldungPage';

// ✅ Registrierungshelfer (Turniertag-Login + Dashboard)
import RegStaffDashboard from './pages/RegStaffDashboard';

// ✅ Einwaage-Helfer (Turniertag-Login + Dashboard)
import EinwaageStaffPage from './pages/EinwaageStaffPage';

// ✅ Kampfrichter-App (Turniertag-Login)
import JudgeApp from './pages/JudgeApp';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import MatDisplay from './pages/MatDisplay';

// ✅ Personal-App (Turniertag-Login)
import StaffDashboard from './pages/StaffDashboard';
import PersonalZugangPage from './pages/PersonalZugangPage';

// ✅ CSS Imports - Korrigierte Pfade
import './styles/index.css';
// Login.css hing bis 18.10.2026 an der alten /login-Seite (ClubLogin), trägt
// aber auch .modal-backdrop, .modal-close, .spinner, .section-header u. a.,
// die andere Seiten mitbenutzen. Darum bleibt sie im Bündel.
import './styles/Login.css';






import KiAssistent from './components/ki/KiAssistent';

/** Alte Adresse /login → /anmelden, Zusatz (?turnier=, ?name=) bleibt erhalten. */
function ZurAnmeldung() {
  const { search } = useLocation();
  return <Navigate to={`/anmelden${search}`} replace />;
}

function App() {
  const [isLoggedIn, setIsLoggedIn]       = useState(false);
  const [isAdmin, setIsAdmin]             = useState(false);
  const [clubData, setClubData]           = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [swRegistration, setSwRegistration] = useState(null);
  const navigate = useNavigate();

  // ✅ Automatisches Neuladen bei neuer Version
  useVersionCheck();

  // ✅ Wettkampf 6-Monitor-Betrieb: CSS-Animationen einfrieren wenn TAB versteckt
  // NUR visibilitychange — kein blur/focus, da blur bei jedem Fensterwechsel feuert
  // und fadeIn-Animationen von opacity:0 neu startet (→ "Blinken")
  useEffect(() => {
    const onVis = () => {
      if (document.hidden) {
        document.documentElement.dataset.animPaused = '1';
      } else {
        delete document.documentElement.dataset.animPaused;
      }
    };
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, []);

  // ✅ Theme-Initialisierung beim Start (verhindert Flash of wrong theme)
  useEffect(() => {
    const savedTheme = localStorage.getItem('tda-theme') || 'light';
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  // ✅ Service Worker Update-Event empfangen
  useEffect(() => {
    const handler = (e) => setSwRegistration(e.detail);
    window.addEventListener('sw-update', handler);
    return () => window.removeEventListener('sw-update', handler);
  }, []);

  useEffect(() => {
    // ✅ KORRIGIERT: Prüfe sowohl echte JWT-Tokens als auch Dummy-Tokens
    const token = localStorage.getItem('token');
    const stored = localStorage.getItem('clubData');
    
    if (token && stored) {
      try {
        const parsedClubData = JSON.parse(stored);
        setIsLoggedIn(true);
        
        const admin = parsedClubData.user?.role === 'admin';
        
        setIsAdmin(admin);
        setClubData(parsedClubData);
        
        console.log('✅ Benutzer automatisch eingeloggt:', admin ? 'Admin' : 'Verein');
      } catch (error) {
        console.error('❌ Fehler beim Laden der gespeicherten Daten:', error);
        handleLogout();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps -- laeuft absichtlich nur beim Einhaengen
  }, []);

  const handleLogin = (data) => {
    console.log('🔑 Login-Daten erhalten:', data);
    
    const admin = data.user?.role === 'admin';
    
    if (data.token) {
      localStorage.setItem('token', data.token);
    } else {
      console.error('❌ Kein Token in Login-Response gefunden!', data);
    }
    
    localStorage.setItem('clubData', JSON.stringify(data));
    setIsLoggedIn(true);
    setIsAdmin(admin);
    setClubData(data);
    
    console.log('✅ Login erfolgreich:', admin ? 'Admin' : 'Verein');
    navigate(admin ? '/dashboard' : '/verein', { replace: true });
  };

  const handleLogout = () => {
    console.log('🚪 Logout...');
    
    localStorage.removeItem('token');
    localStorage.removeItem('authToken'); // Legacy-Key cleanup
    localStorage.removeItem('clubData');
    localStorage.removeItem('clubId');
    localStorage.removeItem('vereins_id');
    
    setIsLoggedIn(false);
    setIsAdmin(false);
    setClubData(null);
    navigate('/', { replace: true });
    
    console.log('✅ Logout erfolgreich');
  };

  const handleUpdateClub = (updated) => {
    localStorage.setItem('clubData', JSON.stringify(updated));
    setClubData(updated);
    setShowEditModal(false);
    console.log('✅ Club-Daten aktualisiert');
  };

  // DEBUG: Token-Status anzeigen (nur in Development)
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      const token = localStorage.getItem('token');
      console.log('🔍 Token Status:', {
        isLoggedIn,
        isAdmin,
        hasToken: !!token,
        tokenPreview: token ? token.substring(0, 20) + '...' : 'none'
      });
    }
  }, [isLoggedIn, isAdmin]);

  return (
    <div>
      <OfflineBanner swRegistration={swRegistration} />
      <ErrorBoundary>
      <TabTitel />
      <Routes>
        {/* Öffentlich */}
        <Route path="/" element={<EventsMarketingPage />} />
        {/* Eine Anmeldeseite (18.10.2026): /login leitet mit allen Zusätzen (?turnier=) weiter */}
        <Route path="/login" element={<ZurAnmeldung />} />
        <Route path="/anmelden" element={<AnmeldenPage onLogin={handleLogin} />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/ranking" element={<RankingPage />} />
        {/* Einladung mit Zu-/Absage. Der Token im Pfad ist der Ausweis, kein Login. */}
        <Route path="/einladung/:token" element={<EinladungPage />} />
        {/* Personalkonto: Einladung annehmen bzw. Passwort neu setzen (18.10.2026, V13) */}
        <Route path="/personal-zugang/:token" element={<PersonalZugangPage />} />
        <Route path="/register" element={<ClubRegistrationPage />} />
        <Route path="/fuer-veranstalter" element={<VeranstalterLandingPage />} />
        <Route path="/apps" element={<AppsPage />} />
        <Route path="/kontakt" element={<KontaktPage />} />
        <Route path="/sso" element={<DojoSSOPage />} />
        
        {/* ✅ ERWEITERT: Registration Routes */}
        <Route path="/registration" element={<TurnierRegistrationPage />} />
        <Route 
          path="/registration/bestaetigung" 
          element={
            isLoggedIn 
              ? <AnmeldungBestaetigung />
              : <Navigate to="/" replace />
          } 
        />

        {/* ✅ Öffentliche Prüfungsanmeldung */}
        <Route path="/pruefungen" element={<PruefungsAnmeldungPage />} />

        {/* ✅ QR Schnellregistrierung (öffentlich, kein Login) */}
        <Route path="/quick-reg/:token" element={<QuickRegPage />} />
        <Route path="/voranmeldung/:token" element={<VoranmeldungPage />} />

        {/* ✅ Registrierungshelfer */}
        {/* Aufgabe 132: alte Anmeldeadressen → gemeinsames Fenster (gedruckte Zettel, Lesezeichen) */}
        <Route path="/reg-login" element={<Navigate to="/anmelden" replace />} />
        <Route path="/reg" element={<RegStaffDashboard />} />

        {/* ✅ Einwaage-Helfer */}
        <Route path="/einwaage-login" element={<Navigate to="/anmelden" replace />} />
        <Route path="/einwaage-staff" element={<EinwaageStaffPage />} />

        {/* ✅ Kampfrichter-App */}
        {/* Eine Route mit optionaler Matte: ein Wechsel /judge -> /judge/2
            behält die Anmeldung (gleiche Route, kein Neuaufbau). */}
        <Route path="/judge/:matNr?" element={<JudgeApp />} />
        <Route path="/display/:matNr" element={<MatDisplay />} />

        {/* ✅ Personal-App (Turniertag-Login) */}
        <Route path="/staff-login" element={<Navigate to="/anmelden" replace />} />
        <Route path="/staff" element={<StaffDashboard />} />

        {/* ✅ Öffentliche Ergebnisseite */}
        <Route path="/turnier/:id/ergebnisse" element={<TurnierErgebnissePage />} />
        <Route path="/live/:id" element={<OeffentlicheErgebnisse />} />
        <Route path="/umfrage/:token" element={<UmfragePage />} />
        {/* Aufgabe 178: öffentlicher Hallenschirm (Live-Kämpfe, Ergebnisse) */}
        <Route path="/zuschauer/:turnierId" element={<ZuschauerPage />} />

        {/* ✅ Kämpfer-Aufruf Display + Schreiber-Steuerung */}
        <Route path="/aufruf/:turnierId" element={<AufrufDisplayPage />} />
        <Route path="/aufruf-control/:turnierId" element={<AufrufControlPage />} />
        <Route path="/leitstelle/:turnierId" element={<LeitstellePage />} />
        <Route path="/turniertag/:turnierId" element={<TurniertagPage />} />
        <Route path="/ansage/:turnierId" element={<AnsageStationPage />} />

        {/* ✅ Öffentliche Turnier-Detailseite */}
        <Route path="/event/:id" element={<TurnierInfoPage />} />
        <Route path="/veranstaltung/:id" element={<CampRegistrationPage />} />
        {/* alter Link, bereits als Camp-Anmeldelink verschickt */}
        <Route path="/camp/:id" element={<CampRegistrationPage />} />

        {/* ✅ Athleten-Registrierung & persönliches Dashboard */}
        <Route path="/registrieren" element={<RegistrationPage />} />
        <Route path="/athlete/dashboard" element={<AthleteDashboard />} />

        {/* ✅ Vereins-Portal */}
        <Route path="/verein" element={<VereinsDashboard />} />

        {/* ✅ DASHBOARD - Always available, MainDashboard handles auth internally */}
        <Route path="/dashboard/*" element={<MainDashboard />} />

        {/* ✅ ADMIN PLATFORM - Super-Admin only (auth guard inside component) */}
        <Route path="/admin" element={<AdminPlatformDashboard />} />

        {/* ✅ Formen-Schreiber Standalone (eigenes Fenster) */}
        <Route path="/formen-schreiber" element={<FormenSchreiberDashboard />} />

        {/* ✅ SV-Schreiber Standalone (neues dunkles Wertungsportal) */}
        <Route path="/sv-schreiber" element={<SVSchreiberPage />} />

        {/* ✅ Siegerehrung Display Standalone (zweiter Bildschirm) */}
        <Route path="/siegerehrung-display" element={<SiegerehrungDisplayPage />} />
        <Route path="/siegerehrung-display/:turnierId" element={<SiegerehrungDisplayPage />} />

        {/* ✅ Rumble Sieger Display (Festive winner screen) */}
        <Route path="/rumble-sieger-display" element={<RumbleSiegerDisplayPage />} />

        {/* ✅ Winner Display (Japan Dark Prestige) */}
        <Route path="/winner-display" element={<WinnerDisplayPage />} />

        {/* ✅ Bruchtest Display (Vollbild für zweiten Bildschirm) */}
        <Route path="/bruchtest-display" element={<BruchtestDisplayPage />} />

        {/* ✅ Formen Display (Leinwand für die Wertung, auch auf einem zweiten Rechner) */}
        <Route path="/formen-display" element={<FormenDisplayPage />} />

        {/* ✅ Kampfrichtereinteilung (externer Bildschirm, braucht Admin-Anmeldung) */}
        <Route path="/kampfrichter-display/:turnierId" element={<KampfrichterDisplayPage />} />

        {/* Konto & Sicherheit (Zweifaktor) — für Vereine wie Admins */}
        <Route path="/sicherheit" element={<SicherheitPage />} />

        {/* ✅ ERWEITERT: Club-Bereich - Auch Vereine nutzen jetzt das Dashboard */}
        {isLoggedIn && !isAdmin && (
          <>
            <Route path="/profil"  element={<MeineSchulePage />} />
            <Route path="/turniere" element={<TurnierListe />} />
          </>
        )}

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </ErrorBoundary>

      {/* Vereins-Modal */}
      {isLoggedIn && showEditModal && (
        <ClubEditModal
          isOpen={showEditModal}
          onClose={() => setShowEditModal(false)}
          clubData={clubData}
          onUpdate={handleUpdateClub}
        />
      )}
      
      {/* KI-Assistent: ein Bauteil fuer alle Zugaenge. Welche Rolle gilt,
          entscheidet der Server am Token, nicht der Browser. */}
      <KiAssistent />

      {/* ✅ NEU: Development Debug Panel */}
      {process.env.NODE_ENV === 'development' && (
        <div style={{
          position: 'fixed',
          bottom: '10px',
          right: '10px',
          background: 'rgba(0,0,0,0.8)',
          color: 'white',
          padding: '10px',
          borderRadius: '5px',
          fontSize: '12px',
          zIndex: 9999
        }}>
          Status: {isLoggedIn ? (isAdmin ? 'Admin' : 'User') : 'Guest'} | 
          Token: {localStorage.getItem('token') ? '✅' : '❌'}
        </div>
      )}
    </div>
  );
}

export default App;